<template>
  <v-container
    fluid
    class="bg"
    align-center
    fill-height
    style="display:flex; justify-content:center;"
    pt-0
    mt-0
    pb-0
    mb-0
  >
    <v-responsive height="100%" class="hidden-sm-and-down">
      <v-container fluid fill-height pb-0>
        <v-layout align-center justify-space-around column mb-5>
          <v-flex xs12 md12 style="">
            <v-layout wrap justify-center style="text-align: center;">
              <v-flex xs12 md12 sm12 mt-5>
                <!--<img
                  src="../assets/images/royal.png"
                  alt=""
                  width="100"
                  class="royal-image"
                />-->
                <div style="height: 100px;"></div>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center mb-2>
              <v-flex md12 sm9 xs12>
                <h1
                  class="font-shadow font-weight-bold"
                  style="text-align: center;"
                >
                  โครงการ 100 ล้านกล้า สานต่อรอยพ่อ เพื่อแผ่นดิน
                </h1>
                <h2
                  class="font-shadow mb-1"
                  style="text-align: center;line-height: 30px;font-size: 30px !important;font-weight: 600;"
                >
                  เฉลิมพระเกียรติ 100 ปี วันพระราชสมภพพระบาทสมเด็จพระบรมชนกาธิเบศร<br />
                  มหาภูมิพลอดุลยเดชมหาราช บรมนาถบพิตร
                </h2>
                <v-divider class="my-3"></v-divider>
                <div
                  v-if="sumPlant !== null && sumPlant >= 0"
                  style="display:flex; justify-content: center; margin-top: 40px; "
                >
                  <h3 class="font-shadow2" style="font-size: 30px">
                    ต้นไม้ที่ลงทะเบียนแล้ว&nbsp;
                  </h3>
                  <h3 class="el number font-shadow2"></h3>
                  <h3 class="font-shadow2" style="font-size: 30px">
                    &nbsp;ต้น
                  </h3>
                </div>
              </v-flex>
              <v-flex md3 sm12 xs12 mt-5>
                <v-btn
                  class="mx-0"
                  round
                  block
                  color="primary"
                  @click="gotoIndex()"
                >
                  <p style="font-size:23px;margin-bottom:0px">ร่วมปลูกต้นไม้</p>
                </v-btn>
                <div
                  style="text-align:center;"
                  class="mt-4"
                >
                  <img src="../assets/images/logo.png" alt="" width="110" />
                  <!-- <v-btn flat round href="https://plant.forest.go.th/static/plant-knowledge/manual.pdf" target="_blank"><v-icon class="mr-1">chrome_reader_mode</v-icon>คู่มือการใช้งาน</v-btn> -->
                </div>
                <!-- <img src="../assets/images/logo.png" alt="" width="300px"> -->
              </v-flex>
            </v-layout>
            <!-- <v-layout row wrap>
      <v-flex xs12 md12 sm12 style="justify-content: center;display:flex;align-items:flex-end" class="footer">
        <span style="font-size: 22px; text-decoration: underline; cursor: pointer" @click="gotoIndex()">เข้าสู่เว็บไซต์</span>
      </v-flex>
      </v-layout> -->
          </v-flex>
        </v-layout>
        <!-- <div class="footer">
    <span style="font-size: 22px; text-decoration: underline; cursor: pointer" @click="gotoIndex()">เข้าสู่เว็บไซต์</span>
  </div> -->
      </v-container>
    </v-responsive>

    <v-responsive height="100%" class="hidden-md-and-up">
      <v-container fluid fill-height justify-center align-center pb-0 pt-0>
        <v-layout align-center justify-space-around column>
          <v-flex xs12 md12 mt-5>
            <v-layout row wrap justify-center>
              <v-flex
                xs12
                md12
                sm12
                style="text-align:center;margin-top: 10px;margin-bottom: 10px;"
              >
                <!-- <v-img
                  :src="require('../assets/images/royal.png')"
                  alt=""
                  height="100"
                  contain
                ></v-img> -->
                <div style="height: 100px;"></div>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
              <v-flex md10 sm10 xs10 style="text-align: center;">
                <h1
                  class="font-for-mobile-main font-shadow font-weight-bold mt-0"
                  style="margin-bottom: 5px;"
                >
                  โครงการ 100 ล้านกล้า สานต่อรอยพ่อ เพื่อแผ่นดิน
                </h1>
                <h2
                  class="font-for-mobile-sub font-shadow font-weight-bold mt-0 mb-1"
                >
                  เฉลิมพระเกียรติ 100 ปี วันพระราชสมภพพระบาทสมเด็จพระบรมชนกาธิเบศร<br />
                  มหาภูมิพลอดุลยเดชมหาราช บรมนาถบพิตร
                </h2>
                <v-divider class="my-3"></v-divider>
                <div v-if="sumPlant !== null && sumPlant >= 0">
                  <h3
                    class="font-shadow2 font-for-mobile-middle"
                    style="justify-content: center;"
                  >
                    ต้นไม้ที่ลงทะเบียนแล้ว
                  </h3>
                  <h3
                    class="el font-shadow2 number-mobile"
                    style="justify-content: center;color: #71231a;"
                  ></h3>
                  <h3
                    class="font-shadow2 font-for-mobile-middle"
                    style="justify-content: center;"
                  >
                    ต้น
                  </h3>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
              <v-flex md9 sm6 xs6 mt-4>
                <v-btn
                  class="mx-0"
                  round
                  block
                  color="primary"
                  @click="gotoIndex()"
                >
                  <p class="mb-0">ร่วมปลูกต้นไม้</p>
                </v-btn>

                <!-- <v-btn flat round href="https://plant.forest.go.th/static/plant-knowledge/manual.pdf" target="_blank" color="white"><v-icon class="mr-1">chrome_reader_mode</v-icon>คู่มือการใช้งาน!-->
                <!-- <div class=""> -->
                <!-- <img src="../assets/images/logo.png" alt="" width="290"> -->
                <!-- </div> -->
                <div
                  class="pt-4"
                  style="text-align:center;"
                >
                  <img src="../assets/images/logo.png" alt="" width="100px" />
                </div>
              </v-flex>
            </v-layout>
            <!-- <v-layout row wrap>
      <v-flex xs12 md12 sm12 style="justify-content: center;display:flex;align-items:flex-end">
        <span style="font-size: 20px; text-decoration: underline; cursor: pointer;font-weight: bold;" @click="gotoIndex()">เข้าสู่เว็บไซต์</span>
      </v-flex>
      </v-layout> -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-responsive>
  </v-container>
</template>

<script>
// import _ from "lodash";

var $ = require("jquery");
export default {
  data() {
    return {
      startValue: 0,
      interval: null,
      sumPlant: null,
    };
  },
  created() {
    this.queryStat();
    this.interval = setInterval(() => {
      this.queryStat();
    }, 3000);
  },
  watch: {
    sumPlant(newVal, oldVal) {
      var me = this;
      if (newVal === null) return;
      this.$nextTick(() => {
        $({ someValue: oldVal || 0 }).animate(
          { someValue: newVal },
          {
            duration: 1000,
            easing: "swing",
            step: function() {
              $(".el").text(me.commaSeparateNumber(Math.round(this.someValue)));
            },
            complete: () => {
              $(".el").text(me.commaSeparateNumber(Math.round(newVal)));
              me.startValue = newVal;
            },
          }
        );
      });
    },
  },

  methods: {
    async queryStat() {
      try {
        const response = await this.axios.post(
          process.env.VUE_APP_IPFLASK + "/totalUserPlant"
        );
        if (
          response.data &&
          response.data[0] &&
          Object.prototype.hasOwnProperty.call(response.data[0], "totalUserPlant")
        ) {
          if (Object.prototype.hasOwnProperty.call(response.data[0], "showStatistic")) {
            this.$store.commit("setShowStatistic", response.data[0].showStatistic);
          }
          const val = response.data[0].totalUserPlant;
          const parsed = parseInt(val);
          if (!isNaN(parsed) && parsed >= 0) {
            this.sumPlant = parsed;
          }
        }
      } catch (error) {
        console.error("Error fetching plant count:", error);
      }
    },
    gotoIndex() {
      this.$router.push("/seeding");
    },
    commaSeparateNumber(val) {
      return val.toLocaleString();
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.bg {
  background-image: url("../assets/images/bg.jpg");
  background-size: cover;
  background-position: center;
  /* background-repeat: repeat-x; */
}

.font-shadow {
  text-shadow: 1px 1px 10px rgb(255, 255, 255);
  color: #7b4d0f;
  font-size: 34px !important;
}
.font-shadow2 {
  text-shadow: 4px 2px 11px rgb(255, 255, 255);
  color: #824a00;
}
.font-shadow3 {
  text-shadow: 1px 1px 11px rgb(255, 255, 255);
  color: #984d00;
  font-size: 44px !important;
  letter-spacing: 0px !important;
}

.footer {
  font-weight: 700;
  bottom: 0;
  text-align: center;
  width: 100%;
}

.display-1 {
  line-height: 30px !important;
}
/* .line37{
    line-height: 42px !important;
  } */
.font100 {
  font-size: 82px !important;
  line-height: 80px !important;
}

.line95 {
  line-height: 0.6 !important;
}

@media only screen and (max-width: 320px) {
  .font-for-mobile-main {
    font-size: 20px !important;
    line-height: 19px !important;
  }
  .font-for-mobile-middle {
    font-size: 19px !important;
    line-height: 18px;
  }
  .font-for-mobile-sub {
    font-size: 16px !important;
    line-height: 19px !important;
  }
  .number-mobile {
    font-size: 40px !important;
    font-weight: 600;
    line-height: 46px !important;
    letter-spacing: normal !important;
    font-family: "Chakra Petch" !important;
  }
}

@media only screen and (min-width: 321px) and (max-width: 600px) {
  .font-for-mobile-main {
    font-size: 22px !important;
    line-height: 20px;
  }
  .font-for-mobile-middle {
    font-size: 20px !important;
    line-height: 20px;
  }
  .font-for-mobile-sub {
    font-size: 16px !important;
    line-height: 20px !important;
  }
  .number-mobile {
    font-size: 34px !important;
    font-weight: 600;
    line-height: 46px !important;
    letter-spacing: normal !important;
    font-family: "Chakra Petch" !important;
  }
}

@media only screen and (min-width: 601px) {
  .font-for-mobile-main {
    font-size: 40px !important;
    line-height: 40px !important;
  }
  .font-for-mobile-middle {
    font-size: 30px !important;
    margin-top: 5px !important;
  }
  .font-for-mobile-sub {
    font-size: 26px !important;
    line-height: 30px !important;
    margin-bottom: 10px;
  }
  .number-mobile {
    font-size: 60px !important;
    font-weight: 600;
    line-height: 46px !important;
    letter-spacing: normal !important;
    font-family: "Chakra Petch" !important;
  }
}
.number {
  font-size: 90px !important;
  font-weight: 600;
  line-height: 46px !important;
  letter-spacing: normal !important;
  font-family: "Chakra Petch" !important;
  color: #71231a;
}

.royal-image {
  text-shadow: 1px 1px 11px rgb(255, 255, 255);
}
</style>
